import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import ChatWidget from './ChatWidget';
import SiteNav from './SiteNav';
import SiteFooter from './SiteFooter';

const T = {
  fa: {
    dir: 'rtl',
    title: 'سوالات متداول',
    subtitle: 'پاسخ سوالاتی که معمولاً درباره‌ی ثبت‌نام، لیست انتظار و مراحل بازی پرسیده می‌شود.',
    empty: 'در حال حاضر سوالی ثبت نشده است.',
    loading: 'در حال بارگذاری...'
  },
  en: {
    dir: 'ltr',
    title: 'Frequently Asked Questions',
    subtitle: 'Answers to common questions about signup, the waitlist, and the game journey.',
    empty: 'No questions have been added yet.',
    loading: 'Loading...'
  }
};

function FAQItem({ faq, isOpen, onToggle, dir }) {
  return (
    <div
      style={{
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(212,160,23,0.25)',
        borderRadius: 12,
        marginBottom: 14,
        overflow: 'hidden',
        transition: 'border-color .2s'
      }}
    >
      <button
        onClick={onToggle}
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: '18px 20px',
          color: '#f3e9d2',
          fontSize: '1.05rem',
          fontWeight: 600,
          textAlign: 'right',
          direction: dir
        }}
      >
        <span>{faq.question}</span>
        <span style={{ color: '#d4af37', fontSize: '1.3rem', flexShrink: 0, marginInlineStart: 12 }}>
          {isOpen ? '−' : '+'}
        </span>
      </button>
      {isOpen && (
        <div
          style={{
            padding: '0 20px 18px',
            color: '#c9bfa8',
            lineHeight: 1.9,
            whiteSpace: 'pre-line'
          }}
        >
          {faq.answer}
        </div>
      )}
    </div>
  );
}

export default function FAQPage() {
  const { i18n } = useTranslation();
  const lang = i18n.language || 'fa';
  const t = T[lang] || T.en;

  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    let mounted = true;
    axios.get('/api/faq')
      .then((res) => {
        if (mounted && res.data?.success) {
          setFaqs(res.data.faqs || []);
        }
      })
      .catch(() => {})
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  return (
    <div
      dir={t.dir}
      style={{
        minHeight: '100vh',
        background: 'radial-gradient(circle at 50% 0%, #241a3a 0%, #140f22 55%, #0c0916 100%)'
      }}
    >
      <SiteNav />
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '120px 20px 80px' }}>
        <h1 style={{ color: '#f3e9d2', fontSize: '2.2rem', textAlign: 'center', marginBottom: 8 }}>
          {t.title}
        </h1>
        <p style={{ color: '#a396c2', textAlign: 'center', marginBottom: 40 }}>{t.subtitle}</p>

        {loading && (
          <p style={{ color: '#a396c2', textAlign: 'center' }}>{t.loading}</p>
        )}

        {!loading && faqs.length === 0 && (
          <p style={{ color: '#a396c2', textAlign: 'center' }}>{t.empty}</p>
        )}

        {!loading && faqs.map((faq) => (
          <FAQItem
            key={faq._id}
            faq={faq}
            isOpen={openId === faq._id}
            onToggle={() => setOpenId(openId === faq._id ? null : faq._id)}
            dir={t.dir}
          />
        ))}
      </div>
      <SiteFooter />
      <ChatWidget />
    </div>
  );
}
